import { render, staticRenderFns } from "./QRStock.vue?vue&type=template&id=0ef41d04&scoped=true&"
import script from "./QRStock.vue?vue&type=script&lang=js&"
export * from "./QRStock.vue?vue&type=script&lang=js&"
import style0 from "./QRStock.vue?vue&type=style&index=0&id=0ef41d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef41d04",
  null
  
)

export default component.exports